/* jshint esversion: 6 */

import React from 'react';
import PropTypes from 'prop-types';

class WebsiteWidgetPopout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  componentDidMount() {
    if (this.popout) return;
    if (this.props.popoutText === null) return;

    this.popout = setTimeout(() => {
      this.setState({show: true});
      this.props.onPopout();
    }, 2000);
  }

  closePopout(e) {
    e.stopPropagation();
    this.setState({show: false}, this.props.onClose);
  }

  render() {
    if (this.props.disabled) {
      clearTimeout(this.popout);
      return null;
    }

    if (!this.state.show) return null;

    return (
      <div id="popout" className={this.state.show ? 'opening' : 'hide'}>
        <div className="arrow-box no-select">
          <div id="close-popout" className="no-select" onClick={(e) => this.closePopout(e)}>×</div>
          {this.props.popoutText}
        </div>
      </div>
    );
  }
}

WebsiteWidgetPopout.propTypes = {
  disabled: PropTypes.bool,
  popoutText: PropTypes.string,
  onPopout: PropTypes.func,
  onClose: PropTypes.func,
};

export default WebsiteWidgetPopout;
